import IdentityVerification from "./identity-verification";
import IdentityConfirm from "./identity-confirm";

export default IdentityVerification;

export {
    IdentityVerification,
    IdentityConfirm,
}